import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useWebhookList = (groupId: string) => {
    return useQuery(queries.webhooks.list(groupId));
};
